import { L, config, state } from '../state';
import { $ } from './modal';

function set(id: string, text: string): void {
  const el = $(`#${id}`);
  if (el) el.textContent = text;
}

export function updateNetwork(): void {
  const online = navigator.onLine;
  const home = L().home;
  set('netText', online ? home.online : home.offline);
  $('#netLive')?.classList.toggle('off', !online);
  $('#statusDot')?.classList.toggle('off', !online);
}

export function updateClock(): void {
  const el = $('#clockLive');
  if (!el) return;
  el.textContent = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).format(new Date());
}

/**
 * Datos del operador en la barra lateral.
 *
 * Ocupa el hueco que dejaron los cuatro accesos duplicados: eran los mismos
 * que las tarjetas. Se usan sólo valores configurados en Fleet Control, sin
 * texto nuevo que traducir, y cada línea se oculta si no está configurada.
 */
function renderOperatorPanel(): void {
  const panel = $('#operatorPanel');
  if (!panel) return;

  const operator = config.tenantName && config.tenantName !== 'Talkxi' ? config.tenantName : '';

  // Sin tablet vinculada no hay datos reales de operador: se muestran los
  // valores por defecto (4 plazas y demás), que sueltos no dicen nada.
  if (operator === '') {
    panel.hidden = true;
    return;
  }

  const area = String(config.serviceArea ?? '').trim();
  const seats = Number(config.maxPassengers) || 0;

  const chip = (id: string, value: string) => {
    const el = $(`#${id}`);
    if (!el) return;
    el.hidden = value === '';
    const span = el.querySelector('span');
    if (span) span.textContent = value;
  };

  chip('factOperator', operator);
  chip('factArea', area);
  chip('factSeats', seats > 0 ? String(seats) : '');

  panel.hidden = false;
}

export function renderHome(): void {
  const lang = L();
  const home = lang.home;
  document.documentElement.lang = state.lang;

  // Marca del operador (por defecto Talkxi).
  const brand = config.brandName || 'Talkxi';
  set('brandName', brand);
  set('heroBrand', brand);
  document.querySelector('.brand-name')!.textContent = brand;
  document.querySelector('.trust-brand')!.textContent = brand;

  renderOperatorPanel();

  set('heroGreeting', home.greeting);
  set('heroSub', home.sub);

  set('cardChatTitle', home.help);
  set('cardChatDesc', home.helpDesc);
  set('cardBookTitle', home.book);
  set('cardBookDesc', home.bookDesc);
  set('cardLangsTitle', home.langs);
  set('cardLangsDesc', home.langDesc);
  set('cardReviewsTitle', home.reviews);
  set('cardReviewsDesc', home.reviewDesc);

  set('searchPlaceholder', home.search);

  set('foot1', home.foot1);
  set('foot2', home.foot2);
  set('foot3', home.foot3);
  set('foot4', home.foot4);

  // Sólo el código, sin bandera: Windows y algunos Android no dibujan los
  // emoji de bandera y se veía "ES ES". En el selector de idioma sí van.
  set('langLive', state.lang.toUpperCase());

  updateNetwork();
}

export function initHome(): void {
  window.addEventListener('online', updateNetwork);
  window.addEventListener('offline', updateNetwork);
  setInterval(updateClock, 15_000);
  updateClock();
  renderHome();
}
